module.exports = __webpack_public_path__ + "media/5s.d2b4059e.mp3";